import { render, staticRenderFns } from "./SelectAddressList.vue?vue&type=template&id=55d59ce7&scoped=true&"
import script from "./SelectAddressList.vue?vue&type=script&lang=js&"
export * from "./SelectAddressList.vue?vue&type=script&lang=js&"
import style0 from "./SelectAddressList.vue?vue&type=style&index=0&id=55d59ce7&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55d59ce7",
  null
  
)

export default component.exports